import * as React from 'react';
import { Button } from '@shared/ui-react/Button';
import { MapToolsStore } from '@openlayers/MapToolsStore';
import { MeasurementEditor } from '@openlayers/map-measurements/MeasurementEditComponent';
import { getMeasureToolsCoords } from '@shared/openlayers/ol-utils';
import { cs } from '@shared/utils/utils-classname';
import { observer } from 'mobx-react';
import { AiMeasurements } from './tool-utils';
import { Card } from 'primereact/card';


@observer
export class MapToolsButtons extends React.Component<{
    toolsStore: MapToolsStore;
    treeData?: ITreeData | null;
    showClearMeasurementsLabel?: boolean;
    openCrossSectionWindow: Function;
    openLongSectionWindow: Function;
}> {
    render() {
        const store = this.props.toolsStore ?? (window as any)?.mapTools;

        return (
            <>
                <div className='btn-group'>
                    <Button secondary icon='iki iki-cursor' onClick={store.deactivateAllTools} className={cs({ active: !store.activeTool })} />
                    <Button
                        secondary
                        icon='iki iki-measure'
                        onClick={store.activateDistanceTool}
                        title={__('js_map_measuring_tools.distance') + '\n' + __('js_map_measuring_tools.modifiers_description')}
                        className={cs({ active: store.activeTool === store.distanceTool })}
                    />
                    <Button
                        secondary
                        onClick={store.activateAreaTool}
                        title={`${__('js_map_measuring_tools.area')}\n${__('js_map_measuring_tools.modifiers_description')}`}
                        className={cs({ active: store.activeTool === store.areaTool })}
                    >
                        <span>
                            <i className='iki iki-area'></i>
                            <sup>2</sup>
                        </span>
                    </Button>
                    <Button
                        secondary
                        onClick={store.activateVolumeTool}
                        title={__('js_map_measuring_tools.dem_volume_tool')}
                        className={cs({ active: store.activeTool === store.volumeTool })}
                    >
                        <span>
                            <i className='iki iki-area'></i>
                            <sup>3</sup>
                        </span>
                    </Button>

                    {store.hasMeasurements && (
                        <Button
                            secondary
                            icon='iki iki-cross'
                            id='map__clear-measurements'
                            onClick={store.clearMeasurements}
                            style={{ order: this.props.showClearMeasurementsLabel ? 1 : 5 }}
                            tooltip={__('js_map.tools.clear_measurements')}
                        >
                            {this.props.showClearMeasurementsLabel ? __('js_map.tools.clear_measurements') : null}
                        </Button>
                    )}
                </div>

                <div className='btn-group'>
                    <Button
                        secondary
                        icon='iki iki-cross-section'
                        onClick={this.props.openCrossSectionWindow}
                        disabled={!store.hasMapAlignment}
                        title={__('js_map_measuring_tools.draw_cross_section')}
                    />
                    <Button
                        secondary
                        icon='iki iki-draw-cross-section'
                        onClick={store.activateFreeCsTool}
                        title={__('js_map_measuring_tools.draw_free_cross_section')}
                        className={cs({ active: store.activeTool === store.freeCrossSectionTool })}
                    />
                    {typeof this.props.openLongSectionWindow === 'function' && (
                        <>
                            <Button
                                secondary
                                icon='iki iki-long-section'
                                onClick={this.props.openLongSectionWindow}
                                disabled={!store.hasMapAlignment}
                                title={__('js_map_measuring_tools.draw_long_section')}
                            />
                            <Button
                                secondary
                                icon='iki iki-draw-long-section'
                                onClick={store.activateLongCsTool}
                                disabled={!store.hasMapAlignment}
                                title={__('js_map_measuring_tools.draw_free_long_section')}
                                className={cs({ active: store.activeTool === store.freeLongSectionTool })}
                            />
                        </>
                    )}
                </div>

                {store.activeTool === store.distanceTool ||
                store.activeTool === store.areaTool ||
                store.activeTool === store.distanceTool ||
                store.activeTool === store.volumeTool ? (
                    <div className='btn-group measure-tools-options' style={{ position: 'fixed', top: 120, right: '40vw', transform: 'translateX(50%)' }}>
                        <Button secondary onClick={store.toolInteractions.toggleModifyUserEnabled} className={cs({ active: store.toolInteractions.modifyInteractionUserEnabled })}>
                            {__('js_map_measuring_tools.modify')} [m]
                        </Button>
                        <Button
                            secondary
                            onClick={store.toolInteractions.toggleSnapModelsUserEnabled}
                            className={cs({ active: store.toolInteractions.snapModelsInteractionUserEnabled })}
                        >
                            {__('js_map_measuring_tools.snap_to_models')} [s]
                        </Button>
                        <Button
                            secondary
                            onClick={store.toolInteractions.toggleSnapGonsUserEnabled}
                            onContextMenu={store.toolInteractions.setGons}
                            className={cs({ active: store.toolInteractions.snapGonsInteractionUserEnabled })}
                        >
                            {__('js_map_measuring_tools.snap_to_n_gons', store.toolInteractions.gonsInterval)} [g]
                        </Button>
                        <Button secondary onClick={store.toggleShowSegmentLabels} className={cs({ active: store.showSegmentLabels })}>
                            {__('js_map_measuring_tools.segment_labels')}
                        </Button>
                    </div>
                ) : null}

                {AiMeasurements.groups.length > 0 && (
                    <div className='ai-measurements-list' style={{ 
                        position: 'fixed', 
                        top: 170, 
                        right: '40vw', 
                        transform: 'translateX(50%)',
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '8px',
                        maxWidth: '90vw',
                        padding: '0 10px'
                    }}>
                        {AiMeasurements.groups.map(group => (
                            <Card 
                                key={group.id}
                                className="p-card-sm"
                                style={{ 
                                    background: 'rgba(255, 255, 255, 0.95)',
                                    width: '150px',
                                    height: '100px',
                                    position: 'relative',
                                    flexShrink: 0,
                                    borderRadius: '6px',
                                    border: '1px solid rgba(0,0,0,0.1)',
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                                }}
                            >
                                <i 
                                    className='iki iki-trash' 
                                    style={{ 
                                        position: 'absolute',
                                        top: '6px',
                                        right: '6px',
                                        cursor: 'pointer',
                                        fontSize: '1rem',
                                        color: '#999',
                                        padding: '4px',
                                        zIndex: 1
                                    }}
                                    onClick={() => {
                                        group.features.forEach(feature => {
                                            const store = this.props.toolsStore ?? (window as any)?.mapTools;
                                            store.removeMeasurement(feature);
                                        });
                                        AiMeasurements.removeGroup(group);
                                    }}
                                    title={__('general.delete')}
                                />
                                
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                                    {group.text && (
                                        <span style={{ 
                                            fontSize: '0.8rem', 
                                            fontWeight: 500, 
                                            color: '#333',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '100%',
                                            lineHeight: '1.2'
                                        }} title={group.text}>
                                            {group.text}
                                        </span>
                                    )}
                                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#007ad9' }}>
                                            {group.features.length}
                                        </span>
                                        <span style={{ fontSize: '0.8rem', color: '#555' }}>
                                            {group.features.length === 1 ? 'feature' : 'features'}
                                        </span>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>
                )}
            </>
        );
    }

    saveAllMeasurements = () => {
        const store = this.props.toolsStore;
        const coords = getMeasureToolsCoords(store.distanceTool, store.areaTool);
        MeasurementEditor.open(null, this.props.treeData ?? null, this.props.toolsStore.simpleMeasurementsStore, coords);
    };
}
